'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import { CollectionCard } from './CollectionCard';
import { useCollections } from '@/lib/hooks/useCollections';
import { Collection as ContextCollection } from './CollectionsContext';
import { CollectionsQuery } from '@/lib/api/types';
import { FilterView, FilterViewProps } from '@/components/ui/filter-view';
import { UseInfiniteQueryOptions } from '@tanstack/react-query';
import * as _ from 'es-toolkit';
interface CollectionGridViewProps {
  collections?: ContextCollection[];
  query?: CollectionsQuery;
  variant?: 'full' | 'embedded';
  isOwner?: boolean;
  linkCard?: boolean;
  canFilter?: boolean;
  initialSearchQuery?: string;
  initialSelectedTags?: string[];
  onSearchChange?: (query: string) => void;
  onTagsChange?: (tags: string[]) => void;
  useQueryOptions?: Partial<UseInfiniteQueryOptions>;
  filterViewProps?: Partial<FilterViewProps>;
  emptyState?: {
    title?: string;
    description?: string;
    action?: React.ReactNode;
  };
  headerAction?: React.ReactNode;
}
export function CollectionGridView(t0) {
  const $ = _c(47);
  const {
    collections: providedCollections,
    query,
    variant: t1,
    isOwner: t2,
    linkCard: t3,
    canFilter: t4,
    initialSearchQuery: t5,
    initialSelectedTags: t6,
    onSearchChange,
    onTagsChange,
    useQueryOptions,
    filterViewProps,
    emptyState,
    headerAction
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const isOwner = t2 === undefined ? false : t2;
  const linkCard = t3 === undefined ? true : t3;
  const canFilter = t4 === undefined ? false : t4;
  const initialSearchQuery = t5 === undefined ? "" : t5;
  let t7;
  if ($[0] !== t6) {
    t7 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const initialSelectedTags = t7;
  const [searchQuery, setSearchQuery] = React.useState(initialSearchQuery);
  const [selectedTags, setSelectedTags] = React.useState(initialSelectedTags);
  let t8;
  let t9;
  if ($[2] !== initialSearchQuery) {
    t8 = () => {
      setSearchQuery(initialSearchQuery);
    };
    t9 = [initialSearchQuery];
    $[2] = initialSearchQuery;
    $[3] = t8;
    $[4] = t9;
  } else {
    t8 = $[3];
    t9 = $[4];
  }
  React.useEffect(t8, t9);
  let t10;
  if ($[5] !== onSearchChange) {
    t10 = newSearch => {
      setSearchQuery(newSearch);
      onSearchChange?.(newSearch);
    };
    $[5] = onSearchChange;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const handleSearchChange = t10;
  let t11;
  if ($[7] !== onTagsChange) {
    t11 = newTags => {
      setSelectedTags(newTags);
      onTagsChange?.(newTags);
    };
    $[7] = onTagsChange;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  const handleTagsChange = t11;
  let t12;
  if ($[9] !== handleTagsChange) {
    t12 = filters => {
      const newTags_0 = filters.tags as string[] || [];
      handleTagsChange(newTags_0);
    };
    $[9] = handleTagsChange;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  const handleFilterChange = t12;
  const t13 = searchQuery || undefined;
  const t14 = selectedTags.length > 0 ? selectedTags : query?.tags || undefined;
  const t15 = query?.limit || 20;
  let t16;
  if ($[11] !== query || $[12] !== t13 || $[13] !== t14 || $[14] !== t15) {
    t16 = {
      ...query,
      search: t13,
      tags: t14,
      limit: t15
    };
    $[11] = query;
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  const activeQuery = t16;
  const {
    data: collectionsData,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching
  } = useCollections(providedCollections ? undefined : activeQuery, useQueryOptions);
  let t17;
  bb0: {
    if (providedCollections) {
      t17 = providedCollections;
      break bb0;
    }
    if (!collectionsData) {
      let t18;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = [];
        $[16] = t18;
      } else {
        t18 = $[16];
      }
      t17 = t18;
      break bb0;
    }
    let t18;
    if ($[17] !== collectionsData.pages) {
      const flattenedCollections = _.flatten(collectionsData.pages.map(_temp) || []);
      t18 = flattenedCollections.map(_temp3);
      $[17] = collectionsData.pages;
      $[18] = t18;
    } else {
      t18 = $[18];
    }
    t17 = t18;
  }
  const displayCollections = t17;
  if (error && !providedCollections) {
    let t18;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <div className="py-12 text-center text-gray-500"><p>Error loading collections. Please try again later.</p></div>;
      $[19] = t18;
    } else {
      t18 = $[19];
    }
    return t18;
  }
  const t18 = variant === "full" ? "container mx-auto px-6" : "w-full";
  let t19;
  if ($[20] !== t18) {
    t19 = clsx(t18);
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== headerAction) {
    t20 = headerAction && <div className="mb-8 flex justify-end">{headerAction}</div>;
    $[22] = headerAction;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== canFilter || $[25] !== filterViewProps || $[26] !== handleFilterChange || $[27] !== handleSearchChange || $[28] !== providedCollections || $[29] !== searchQuery || $[30] !== selectedTags) {
    t21 = !providedCollections && canFilter && <div className="mb-8"><FilterView searchEnabled={true} searchValue={searchQuery} onSearch={handleSearchChange} filters={[{
        key: "tags",
        label: "Tags",
        type: "tags"
      }]} activeFilters={{
        tags: selectedTags
      }} onFilterChange={handleFilterChange} {...filterViewProps} /></div>;
    $[24] = canFilter;
    $[25] = filterViewProps;
    $[26] = handleFilterChange;
    $[27] = handleSearchChange;
    $[28] = providedCollections;
    $[29] = searchQuery;
    $[30] = selectedTags;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== displayCollections || $[33] !== emptyState || $[34] !== fetchNextPage || $[35] !== hasNextPage || $[36] !== headerAction || $[37] !== isFetching || $[38] !== isLoading || $[39] !== isOwner || $[40] !== linkCard) {
    t22 = displayCollections.length === 0 && !isLoading ? emptyState ? <div className="text-center py-12">{emptyState.title && <h3 className="text-2xl font-bold text-gray-900 mb-3">{emptyState.title}</h3>}{emptyState.description && <p className="text-gray-600 mb-8 max-w-md mx-auto">{emptyState.description}</p>}{emptyState.action}</div> : <div className="text-center py-12 text-gray-500">No collections found.</div> : <><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">{displayCollections.map(collection_0 => <CollectionCard key={collection_0.id} collection={collection_0} isOwner={isOwner} showMenu={isOwner} linkCard={linkCard} />)}{isOwner && headerAction && <div className="flex items-center justify-center">{headerAction}</div>}</div>{!isFetching && hasNextPage && <button onClick={() => fetchNextPage()} className="w-full px-4 py-3 mt-6 bg-primary-500 text-white font-semibold rounded-xl hover:bg-primary-600 transition-all text-sm sm:text-base">Load more</button>}</>;
    $[32] = displayCollections;
    $[33] = emptyState;
    $[34] = fetchNextPage;
    $[35] = hasNextPage;
    $[36] = headerAction;
    $[37] = isFetching;
    $[38] = isLoading;
    $[39] = isOwner;
    $[40] = linkCard;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t19 || $[43] !== t20 || $[44] !== t21 || $[45] !== t22) {
    t23 = <div className={t19}>{t20}{t21}{t22}</div>;
    $[42] = t19;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
}
function _temp3(collection) {
  return {
    id: collection.id.toString(),
    name: collection.name,
    description: collection.description || undefined,
    image: collection.image || null,
    visibility: collection.isPublic ? "public" as const : "private" as const,
    productIds: collection.items ? collection.items.map(_temp2) : [],
    createdAt: new Date(collection.createdAt)
  };
}
function _temp2(item) {
  return item.id;
}
function _temp(p) {
  return p.collections;
}